const GlobalEvents = [
    'windowFocusChange',
    'windowVisibilityChange',
];

export default GlobalEvents;



// WEBPACK FOOTER //
// ./src/js/events/global-events.js